/**
 * useShopFeatures Hook
 * 
 * Reads shop feature flags from deployment config and provides easy access.
 * Features can be toggled on/off in the deployment JSON config.
 * 
 * Usage:
 *   const features = useShopFeatures();
 *   if (features.reviews) { ... }
 */

import { useApp } from '../../../contexts/AppContext';

const useShopFeatures = () => {
  const { deploymentInfo } = useApp();
  
  // Get shop features from config (if exists)
  const shopConfig = deploymentInfo?.apps?.shop;
  const features = shopConfig?.shopFeatures || {};
  
  // Default all features to false if not configured
  return {
    productVariations: features.productVariations ?? false,
    reviews: features.reviews ?? false,
    wishlist: features.wishlist ?? false,
    stockIndicators: features.stockIndicators ?? false,
    guestCheckout: features.guestCheckout ?? false,
    imageGallery: features.imageGallery ?? false,
    searchAutocomplete: features.searchAutocomplete ?? false,
    deals: features.deals ?? false,
    addressBook: features.addressBook ?? false,
    orderTracking: features.orderTracking ?? false,
    recentlyViewed: features.recentlyViewed ?? false,
    advancedFiltering: features.advancedFiltering ?? false,
    productSpecs: features.productSpecs ?? false,
    invoices: features.invoices ?? false
  };
};

export default useShopFeatures;

